import { forwardRef } from "react";
import { cn } from "@/lib/cn";

/**
 * Application-level Button. Three variants matching the design tokens.
 * Sized for SaaS density (sm = compact, default = comfortable, lg = hero).
 */
const variants = {
  primary:
    "bg-foreground text-background hover:bg-foreground/90 active:bg-foreground/85 border border-transparent",
  secondary:
    "bg-background text-foreground border border-border hover:bg-surface hover:border-foreground/20",
  ghost:
    "bg-transparent text-muted-foreground border border-transparent hover:text-foreground hover:bg-surface",
  brand:
    "bg-brand text-brand-foreground hover:bg-brand/90 active:bg-brand/85 border border-transparent",
};

const sizes = {
  sm: "h-8 px-3 text-xs",
  md: "h-9 px-4 text-sm",
  lg: "h-11 px-6 text-[15px]",
};

export const Button = forwardRef(
  (
    {
      variant = "primary",
      size = "md",
      className,
      children,
      iconLeft,
      iconRight,
      ...props
    },
    ref
  ) => {
    return (
      <button
        ref={ref}
        className={cn(
          "inline-flex items-center justify-center gap-2 rounded-md font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:opacity-50 disabled:pointer-events-none",
          variants[variant],
          sizes[size],
          className
        )}
        {...props}
      >
        {iconLeft && <span className="inline-flex shrink-0">{iconLeft}</span>}
        {children}
        {iconRight && <span className="inline-flex shrink-0">{iconRight}</span>}
      </button>
    );
  }
);
Button.displayName = "Button";

export default Button;
